module.exports = __webpack_public_path__ + "static/img/picture@2x.f2e6c9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsCenter/picture@2x.png
// module id = FF9J
// module chunks = 44